import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import * as Config from '@libs/configs/general-config';

@Directive({
  selector: '[appPhoneInput]',
  standalone: true,
})
export class PhoneInputDirective {
  @Input() public defaultMobilePhone: string = '380';
  @Input() public doubleCountryRegular: RegExp = Config.RegularExpression.ERROR_MOBILE_INPUT_DOUBLE_COUNTRY;
  @Input() public doubleZeroRegular: RegExp = Config.RegularExpression.ERROR_MOBILE_INPUT_DOUBLE_ZERO;
  public phonePattern: RegExp = new RegExp(Config.RegularExpression.MOBILE_PHONE);

  constructor(
    private el: ElementRef,
    private control: NgControl,
  ) {}

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const value = event.clipboardData?.getData('text')?.replace(/\D/g, '') || '';
    const phone = this.formatPhoneNumber(value);

    if (phone) {
      this.control.control?.setValue(phone);
    }
  }

  @HostListener('keydown', ['$event'])
  preventDefaultValueDeletion(event: KeyboardEvent): boolean {
    const input = this.control.control?.value?.toString() || '';
    if ((input.length === 3 || input === this.defaultMobilePhone) && (event.code === 'Backspace' || event.code === 'Delete')) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  @HostListener('keyup')
  inputPhoneNumber(): void {
    const input = this.control.control?.value?.toString() || '';
    if (this.doubleCountryRegular.test(input) || this.doubleZeroRegular.test(input)) {
      this.control.control?.setValue(this.defaultMobilePhone);
    }
  }

  @HostListener('click')
  setValuePhone(): void {
    const input = this.el.nativeElement;
    const val = input.value;
    input.value = '';
    input.value = val;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = this.control.control?.value?.toString() || '';
    if (input.length === 12 && !this.phonePattern.test(input)) {
      this.control.control?.setErrors({ pattern: true });
      this.control.control?.markAsTouched();
    }
  }

  @HostListener('change', ['$event'])
  onChange(event: Event): void {
    const value = this.control.control?.value?.toString() || '';
    const phone = this.formatPhoneNumber(value);

    if (phone) {
      this.control.control?.setValue(phone);
    }
  }

  private formatPhoneNumber(value: string): string | null {
    if (!Boolean(value)) {
      return null;
    }
    if (value.startsWith('380')) {
      return value;
    } else {
      return `${this.defaultMobilePhone}${value.slice(-9)}`;
    }
  }
}
